import React from 'react';
import LoadingButton from "../LoadingButton";
import {useDispatch, useSelector} from "react-redux";
import {resetImage,} from "../../lib/slices/imageSlice";


export default function ResetButton(props) {

    const dispatch = useDispatch();

    // Redux states
    const currentURL = useSelector(state => state.image.currentURL);
    const manipulating = useSelector(state => state.image.manipulating);

    return (
        <LoadingButton
            disabled={currentURL === undefined || manipulating}
            onClick={() => dispatch(resetImage())}
        >
            Reset Image
        </LoadingButton>
    );
}

